import { getYearMonthOptions } from "../../services/dashboard";

/**
 *
 * @param {boolean} includesMonth Boolean to specify is component has a month selector
 * @param {function} setDateOptions Setter from useState to set dateOption parameter
 * @param {function} setSelectedYearSet Setter from useSTate to set selected year in parent component
 * @param {function} setSelectMonth Setter from useSTate to set selected month in parent component
 *
 * @returns Options object with year and month data
 */
export async function getYearAndMonthData(
  includesMonth,
  setDateOptions,
  setSelectedYear,
  setSelectMonth
) {
  const options = {
    mostRecentDate: {
      year: "",
      month: "",
    },
    yearOptions: [],
    monthOptions: {},
  };

  try {
    const responseYearsMonth = await getYearMonthOptions();
    if (responseYearsMonth === "ERROR_LOADING_DATA")
      return "ERROR_LOADING_DATA";

    const { data } = responseYearsMonth;

    options.yearOptions = data.years;
    options.monthOptions = data.months;

    const lastYear = data.years[1].years_code;
    const lastMonthOptions = data.months[lastYear];
    const lastMonth = lastMonthOptions[lastMonthOptions.length - 1].month_num;

    options.mostRecentDate.year = lastYear;
    options.mostRecentDate.month = lastMonth;
    options.firstYear = data.years[data.years.length - 1].years_code;

    if (setDateOptions) setDateOptions(options);

    if (includesMonth) {
      if (setSelectedYear) setSelectedYear(lastYear);
      if (setSelectMonth) setSelectMonth(lastMonth);
    } else {
      if (setSelectedYear) setSelectedYear("HIST");
    }

    return options;
  } catch (error) {
    console.log("Error getting and setting year and month data");
  }
}
